import {
  AssociatedPersonItem,
  QuestionTemplateItemType,
  questionDataType,
} from './addEditQuestionTypes';

import {
  AddEditQuestionsType,
  QuestionSpecificationType,
} from 'types/questions';

export function getPersonAssociation(
  data: AddEditQuestionsType,
  associatedPersons: Array<AssociatedPersonItem>,
): number {
  const personAssociation = associatedPersons.find(
    item => item.id === data?.PersonAssociation,
  );
  let personAssociationId = -1;
  if (personAssociation && personAssociation.name === 'None')
    personAssociationId = 2;
  if (personAssociation && personAssociation.name === 'Caller')
    personAssociationId = 0;
  if (personAssociation && personAssociation.name === 'Person of concern')
    personAssociationId = 1;
  if (data?.PersonAssociation === '') return 2;

  return personAssociationId;
}

export function formatQuestionTypeOptions(
  data: any,
  options: QuestionSpecificationType | undefined,
  lookupFields: Array<string> | undefined,
): any {
  const type = options?.$type;
  if (type === 'LinkQuestionTypeOption') {
    const typeOptions = {
      ...options,
      Type: data?.Type,
      Url: data?.Url,
      LinkDescription: data?.LinkDescription,
    };
    return typeOptions;
  }
  if (type === 'TextQuestionTypeOption') {
    const typeOptions = {
      ...options,
      Type: data?.Type,
      TextQuestionTypeFormatId:
        data?.TextQuestionTypeFormatId === ''
          ? null
          : data.TextQuestionTypeFormatId,
      DefaultValue: data?.DefaultValue,
    };
    return typeOptions;
  }
  if (type === 'LookupTemplateTypeOption') {
    const typeOptions = {
      ...options,
      FieldNames: lookupFields,
    };
    return typeOptions;
  }
  if (type === 'ChoiceQuestionTypeOption') {
    const typeOptions = {
      ...options,
      Type: data?.Type,
    };
    return typeOptions;
  }
  return options;
}

export function formatQuestionData(
  data: AddEditQuestionsType,
  questionSpec: QuestionSpecificationType | undefined,
  personAssociationOptions: Array<AssociatedPersonItem>,
  lookupFields: Array<string> | undefined,
  questionTemplateOptions: Array<QuestionTemplateItemType>,
): questionDataType {
  const questionTypeOption = formatQuestionTypeOptions(
    data,
    questionSpec,
    lookupFields,
  );
  const personAssociation = getPersonAssociation(
    data,
    personAssociationOptions,
  );
  const questionTemplateOptionsToSave = [...questionTemplateOptions]; // edit for choice question
  return {
    questionTypeOption,
    personAssociation,
    questionTemplateOptionsToSave,
  };
}
